import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import type { ApiError } from "../types";

const API_URL = import.meta.env.VITE_API_URL;

// Types for Price Updates
interface TokenPrice {
	tokenId: number;
	priceInUsd: number;
	sellbackPriceInUsd: number;
	sellbackPriceInCredits: number;
}

interface UpdatePricesDto {
	collectionAddress: string;
	prices: TokenPrice[];
}

interface UpdatePricesResponseDto {
	updatedTokens: number[];
}

export const useUpdatePricesMutation = () => {
	const queryClient = useQueryClient();

	return useMutation<UpdatePricesResponseDto, ApiError, UpdatePricesDto>({
		mutationFn: async (data) => {
			const response = await fetch(`${API_URL}/inventory/prices`, {
				method: "POST",
				credentials: "include",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(data),
			});

			if (!response.ok) {
				const error = await response.json();
				throw error;
			}

			return response.json();
		},

		onSuccess: async () => {
			await queryClient.invalidateQueries({
				queryKey: ["nfts"],
			});
			toast.success("Prices updated successfully");
		},
		onError: (error) => {
			toast.error(error.message);
		},
	});
};
